import { createFileRoute } from "@tanstack/react-router";

import { Expedientes } from "@/components/documentos/expedientes";

// Los documentos que entrega finanzas: boleta de venta, documentos del local
// vendido, voucher del pago y ficha del comprador. La pantalla es la lista de
// EXPEDIENTES con lo que le falta a cada uno, porque esa es la pregunta del
// área —«¿cuáles llegaron completos?»— y no cuántas imágenes se leyeron.
export const Route = createFileRoute("/_app/documentos/clientes")({
  component: Expedientes,
});
